import type { TimeframeAssessment, TrendState } from '../../types/market';
import { Badge, type BadgeTone } from '../ui/Badge';

function tone(state: TrendState): BadgeTone {
  if (state.includes('bull')) return 'positive';
  if (state.includes('bear')) return 'negative';
  return 'neutral';
}

export function TimeframeMatrix({ assessments }: { assessments: TimeframeAssessment[] }): React.JSX.Element {
  return (
    <div className="timeframe-matrix">
      {assessments.map((assessment) => (
        <article key={assessment.interval} className="timeframe-cell">
          <div className="timeframe-cell-header">
            <strong>{assessment.interval.toUpperCase()}</strong>
            <Badge tone={tone(assessment.state)}>{assessment.state.replace('-', ' ')}</Badge>
          </div>
          <div className="progress-track" title={`${assessment.candleMaturity.toFixed(1)}% candle maturity`}>
            <div className="progress-fill" style={{ width: `${assessment.candleMaturity}%` }} />
          </div>
          <p>{assessment.summary}</p>
          <p className="timeframe-meta">{assessment.completedCandles} closed candles · active volume pace {assessment.activeVolumePace.toFixed(2)}×</p>
        </article>
      ))}
    </div>
  );
}
